import { ActionButtonProps, Box, Form, ModBox } from '@jfs/ui-new'
import React, { useState } from 'react'
import { useStores } from '../../../../data/store'
import { SelectParentEntityList } from '../CreateEntity/SelectParentEntityList'
import { convFeeForm } from './convFeeForm'

export const headerDataFileContent = [
  {
    title: 'Payment Method',
  },
  {
    title: 'Sub Category',
  },
  {
    title: 'Type',
  },
  {
    title: 'Value',
  },
  {
    title: 'Applicable Lower range (Rs.)',
  },
  {
    title: 'Applicable Higher range (Rs.)',
  },
  {
    title: 'Action',
  },
]

export const columnFlexMapper: any = {
  0: 1,
  1: 1,
  2: 1,
  3: 0.5,
  4: 1.5,
  5: 1.5,
  6: 0.5,
}

const FormBox = ({ children }: any) => {
  return <Box>{children}</Box>
}
const ConvenienceFee = () => {
  const { addConvenienceFeeRow, convenienceFeesList, convFeeListLength, deleteConvenienceFeeRow } = useStores(
    (store) => ({
      addConvenienceFeeRow: store.onboarding.addConvenienceFee,
      convenienceFeesList: store.onboarding.convenienceFees,
      convFeeListLength: store.onboarding.convenienceFees.length,
      deleteConvenienceFeeRow: store.onboarding.deleteConvenienceFeeRow,
    }),
  )

  const [convFee, setConvenienceFee] = useState({
    paymentMethod: undefined,
    subCategory: undefined,
    type: undefined,
    percentageValue: undefined,
    applicableLowerRange: undefined,
    applicableHigherRange: undefined,
  })

  console.log(' ConvenienceFee ')

  const actionButtons = ({ values, isCurrentFormValid }: ActionButtonProps) => {
    if (
      isCurrentFormValid &&
      convFee.paymentMethod === undefined &&
      convFee.subCategory === undefined &&
      convFee.percentageValue === undefined &&
      convFee.type === undefined &&
      convFee.applicableLowerRange === undefined &&
      convFee.applicableHigherRange === undefined
    ) {
      const { paymentMethod, subCategory, type, percentageValue, applicableLowerRange, applicableHigherRange } = values
      setConvenienceFee({
        paymentMethod,
        subCategory,
        type,
        percentageValue,
        applicableLowerRange,
        applicableHigherRange,
      })
    }
  }

  const onAddConvFeeRecord = () => {
    // const id = `${convFeeList.length + 1}`
    if (
      convFee.paymentMethod !== undefined &&
      convFee.subCategory !== undefined &&
      convFee.percentageValue !== undefined &&
      convFee.type !== undefined &&
      convFee.applicableLowerRange !== undefined &&
      convFee.applicableHigherRange !== undefined
    ) {
      addConvenienceFeeRow(
        convFee.paymentMethod,
        convFee.subCategory,
        convFee.type,
        convFee.percentageValue,
        convFee.applicableLowerRange,
        convFee.applicableHigherRange,
      )
      setConvenienceFee({
        paymentMethod: undefined,
        subCategory: undefined,
        type: undefined,
        percentageValue: undefined,
        applicableLowerRange: undefined,
        applicableHigherRange: undefined,
      })
    }
  }

  const onDeleteRow = (item: any) => {
    deleteConvenienceFeeRow(item)
  }
  return (
    <Box f={1} overflow={'auto'} pv={32}>
      <Form
        formData={convFeeForm(true, onAddConvFeeRecord)}
        actionButtons={actionButtons}
        initialValues={{
          paymentMethod: '',
          subCategory: '',
          type: '',
          percentageValue: '',
          applicableLowerRange: '',
          applicableHigherRange: '',
        }}
        container={FormBox}
      />
      <ModBox show={convFeeListLength > 0}>
        <SelectParentEntityList
          title={''}
          data={convenienceFeesList}
          headerTitles={headerDataFileContent}
          columnFlexMapper={columnFlexMapper}
          onDelete={onDeleteRow}
        />
      </ModBox>
    </Box>
  )
}

export { ConvenienceFee }
